import { action, observable, makeObservable } from 'mobx';
import { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ICommonPopupsProps } from '../../../components/PopupManager/PopupManager.types';
import { IPopupOptions, IPopupsStore } from '../PopupsStore';

export class PopupStore<T = any> {
  id: string;
  @observable isHidden = false;
  popups: IPopupsStore;
  openTs: number;
  options: IPopupOptions<T>;
  Component: FC<ICommonPopupsProps<T>>;

  constructor(
    popups: IPopupsStore,
    Component: FC<ICommonPopupsProps<T>>,
    options: IPopupOptions<T> = {}
  ) {
    makeObservable(this);
    this.id = uuidv4();
    this.popups = popups;
    this.options = options;
    this.openTs = Date.now();
    this.Component = Component;

    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.close = this.close.bind(this);
  }

  @action
  hide(): void {
    this.isHidden = true;
  }

  @action
  show(): void {
    this.isHidden = false;
  }

  @action
  close(): void {
    this.popups.closePopup(this);
  }
}
